<template>
  <div id="password-field">
    <div class="form-group with-icon-right">
      <div class="input-group">
        <input
          autocomplete="false"
          :value="value"
          :id="id"
          :class="classes"
          :name="name"
          :type="passwordFieldType"
          :readonly="readonly"
          v-on:input="updateValue($event.target.value)"
          required
        />
        <i
          class="fa icon-right input-icon pointer"
          :class="passwordFieldType == 'password' ? 'fa-eye' : 'fa-eye-slash' "
          @click="switchVisibility()"
        ></i>
        <label class="control-label" :class="value!=''? 'pass-upper-label':''" :for="id" role="button">{{label}}</label>
        <i class="bar"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'password-field',
  props: {
    value: {
      required: true
    },
    name: {
      default: function () {
        return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
      }
    },
    id: {
      type: String,
      required: true
    },
    classes: {
      type: Array
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      default: false
    }
  },
  data () {
    return {
      passwordFieldType: 'password'
    }
  },
  methods: {
    switchVisibility () {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    updateValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
#password-field {
  .pass-upper-label {
    font-size: 0.6rem;
    color: #ffcece;
    font-weight: 600;
    text-transform: uppercase;
    top: -0.6rem;
    left: 0;
  }
}
</style>
